import { render, staticRenderFns } from "./PieChart2.vue?vue&type=template&id=85a59b22&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./PieChart2.vue?vue&type=script&lang=js"
export * from "./PieChart2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports